export function serializeSearchParams(searchParams?: URLSearchParams): string {
  if (!searchParams) {
    return '';
  }

  const queryString = searchParams.toString();

  return queryString ? `?${queryString}` : '';
}
